/**
 * Created by i.lovenkov on 14.10.16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _components2 = require('components');

var _CartProduct = require('components/CartProduct');

require('./Description.less');

var _constants = require('redux/constants');

var _reactRouter = require('react-router');

var _utils = require('redux/modules/catalog/utils');

var _catalog = require('redux/actions/catalog');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ShortDescriptionView: {
        displayName: 'ShortDescriptionView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/CartProduct/ShortDescription/default/ShortDescriptionView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var ShortDescriptionView = _wrapComponent('ShortDescriptionView')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        categories: state.catalog.categories,
        lang: state.lang,
        currency: state.currency
    };
}, {
    refreshCatalog: _catalog.refreshCatalog
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(ShortDescriptionView, _Component);

    function ShortDescriptionView(props) {
        (0, _classCallCheck3.default)(this, ShortDescriptionView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ShortDescriptionView.__proto__ || (0, _getPrototypeOf2.default)(ShortDescriptionView)).call(this, props));

        _this.setActiveClick = function (key) {
            return function (e) {
                var elem = document.getElementsByName('inset');
                elem.forEach(function (item) {
                    item.className = '';
                });
                document.getElementById(key).className = 'checked';
            };
        };

        _this.state = {
            countForSendBasket: 1
        };
        return _this;
    }

    (0, _createClass3.default)(ShortDescriptionView, [{
        key: 'getRemainder',
        value: function getRemainder(nestedOffer, quantityParent, product_detail) {
            var _this2 = this;

            if (nestedOffer.childOffer === null) {
                return null;
            }
            if (nestedOffer.quantity > 0) {
                var quantity = void 0;
                var quantityTechCard = void 0;
                quantity = nestedOffer.quantity;
                if (nestedOffer.childOffer.modifier_option_id !== null && nestedOffer.childOffer.modOption === null) {
                    nestedOffer.childOffer.modOption = nestedOffer.childOffer.modifiedOption.reduce(function (mod, modifier) {
                        if (modifier.id === nestedOffer.childOffer.modifier_option_id) {
                            return modifier;
                        }
                        return mod;
                    }, null);
                }
                if (nestedOffer.childOffer.modOption !== null && nestedOffer.childOffer.type_id !== 5) {
                    nestedOffer.childOffer.unit = nestedOffer.childOffer.modOption.unit;
                    if (nestedOffer.childOffer.modOption.storable === true && nestedOffer.childOffer.modOption.storage_strict) {
                        product_detail.storable = true;
                        if (nestedOffer.childOffer.modOption.remainder.length === 0) {
                            product_detail.remainder = [{ quantity: 0 }];
                        } else if (nestedOffer.childOffer.modOption.remainder[0].quantity > 0) {
                            if ((nestedOffer.childOffer.modOption.unit_id === 2 || nestedOffer.childOffer.modOption.unit_id === 8) && nestedOffer.childOffer.modOption.weight && nestedOffer.childOffer.modOption.weight > 0) {
                                quantity = nestedOffer.childOffer.modOption.weight * nestedOffer.quantity;
                            }
                            quantity = quantity * quantityParent;
                            quantityTechCard = Math.floor(nestedOffer.childOffer.modOption.remainder[0].quantity / quantity);
                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
                                product_detail.remainder = [{ quantity: quantityTechCard }];
                            }
                        } else {
                            product_detail.remainder = [{ quantity: 0 }];
                        }
                    }
                }
                if (nestedOffer.childOffer.modOption === null && nestedOffer.childOffer.type_id !== 5) {
                    if (nestedOffer.childOffer.storable === true && nestedOffer.childOffer.storage_strict) {
                        product_detail.storable = true;
                        if (nestedOffer.childOffer.remainder.length === 0) {
                            product_detail.remainder = [{ quantity: 0 }];
                        } else if (nestedOffer.childOffer.remainder[0].quantity > 0) {
                            if ((nestedOffer.childOffer.unit_id === 2 || nestedOffer.childOffer.unit_id === 8) && nestedOffer.childOffer.weight && nestedOffer.childOffer.weight > 0) {
                                quantity = nestedOffer.childOffer.weight * nestedOffer.quantity;
                            }
                            quantity = quantity * quantityParent;
                            quantityTechCard = Math.floor(nestedOffer.childOffer.remainder[0].quantity / quantity);
                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
                                product_detail.remainder = [{ quantity: quantityTechCard }];
                            }
                        } else {
                            product_detail.remainder = [{ quantity: 0 }];
                        }
                    }
                }
                if (nestedOffer.childOffer.type_id === 5) {
                    nestedOffer.childOffer.remainder = [];
                    nestedOffer.childOffer.storable = false;
                    quantity = nestedOffer.quantity * quantityParent;
                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
                        _this2.getRemainder(nestedOfferTwo, quantity, product_detail);
                    });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                product_detail = _props.product_detail,
                lang = _props.lang,
                currency = _props.currency,
                categories = product_detail.categories,
                id_yml = product_detail.id_yml,
                storable = product_detail.storable,
                _product_detail$remai = product_detail.remainder,
                remainder = _product_detail$remai === undefined ? [] : _product_detail$remai,
                seo = product_detail.seo,
                vendor = '',
                old_price = void 0,
                price = 0,
                available = lang['store.common.out_of_stock'],
                child_offers = '',
                add_to_cart = '';

            var seoH1 = product_detail.name;

            if (product_detail.old_price) {
                old_price = _react3.default.createElement(
                    'div',
                    { className: 'price-prev' },
                    _react3.default.createElement(_components2.MoneyValue, {
                        value: product_detail.old_price,
                        icon: currency.icon,
                        iconAfterValue: currency.icon_after_value
                    })
                );
            }

            if (product_detail.vendor) {
                vendor = product_detail.vendor;
            }

            // округляем число до сотых
            if (product_detail.price) {
                price = parseFloat(product_detail.price).toFixed(2);
            }
            storable = product_detail.storable && product_detail.storage_strict;
            if (product_detail.type.slug === 'technology_card') {
                var quantityTechCard = 1;
                product_detail.storable = false;
                product_detail.remainder = [];
                var childOffers = [];
                var childOffer = void 0;
                var childOffersTwo = [];
                var childOfferTwo = void 0;
                var priceComponent = 0;
                var modifierComponent = null;
                var modifierComponentTwo = null;
                var storableComponent = false;
                product_detail.is_quantity_change = false;
                product_detail.nestedOffers.forEach(function (nestedOffer) {
                    if (nestedOffer.quantity > 0 && nestedOffer.childOffer) {
                        modifierComponent = null;
                        if (nestedOffer.childOffer.type_id === 5) {
                            nestedOffer.childOffer.remainder = [];
                            nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
                                _this3.getRemainder(nestedOfferTwo, nestedOffer.quantity, product_detail);
                            });
                        } else {
                            _this3.getRemainder(nestedOffer, quantityTechCard, product_detail);
                        }
                    }
                    if (nestedOffer.is_quantity_change) {
                        product_detail.is_quantity_change = true;
                    }
                });
                remainder[0] = product_detail.remainder[0];
                storable = product_detail.storable;
                if (product_detail.modifier_option_id !== undefined) {
                    product_detail.modifier_option.storable = storable;
                    product_detail.modifier_option.remainder[0] = product_detail.remainder[0];
                }
                price = parseFloat(product_detail.price).toFixed(2);

                if (product_detail.show_composition === true) {
                    var weight = 0;
                    var countOffers = 0;
                    child_offers = _react3.default.createElement(
                        'div',
                        { className: 'no-margin col-xs-12 col-sn-12 col-md-12', style: { paddingTop: '10px' } },
                        _react3.default.createElement(
                            'table',
                            null,
                            _react3.default.createElement(
                                'tbody',
                                null,
                                _react3.default.createElement(
                                    'tr',
                                    { style: { background: '#E0E0E0' } },
                                    _react3.default.createElement(
                                        'th',
                                        { style: { padding: '5px' } },
                                        '#'
                                    ),
                                    _react3.default.createElement(
                                        'th',
                                        { style: { padding: '5px' } },
                                        lang['store.short_description.component_title']
                                    ),
                                    _react3.default.createElement(
                                        'th',
                                        { style: { padding: '5px' } },
                                        lang['store.short_description.quantity']
                                    )
                                ),
                                product_detail.nestedOffers.map(function (item, index) {
                                    weight = item.quantity;
                                    if ((item.childOffer.unit.slug === 'kg' || item.childOffer.unit.slug === 'mg') && item.weight && item.weight > 0) {
                                        weight = item.weight * item.quantity;
                                        if (item.weight < 0.01 && item.quantity < 1 || item.weight < 1 && item.quantity < 0.01) {
                                            weight = item.weight * 1;
                                        }
                                        if (item.weight < 0.1 && item.quantity < 0.1) {
                                            weight = item.weight * 1;
                                        }
                                    }
                                    if (item.quantity > 0) {
                                        countOffers++;
                                        return _react3.default.createElement(
                                            'tr',
                                            { key: index },
                                            _react3.default.createElement(
                                                'td',
                                                { style: { padding: '5px' } },
                                                countOffers
                                            ),
                                            _react3.default.createElement(
                                                'td',
                                                { style: { padding: '5px' } },
                                                item.childOffer.name,
                                                ' ',
                                                item.modifierOption ? '(' + item.modifierOption.name + ')' : ''
                                            ),
                                            _react3.default.createElement(
                                                'td',
                                                { style: {
                                                        padding: '5px',
                                                        textAlign: 'center'
                                                    } },
                                                weight,
                                                ' ',
                                                lang[item.childOffer.unit.title_lang_data]
                                            )
                                        );
                                    }
                                })
                            )
                        )
                    );
                    if (countOffers === 0) {
                        child_offers = '';
                    }
                }
            } else if (product_detail.modifiedOption.length > 0 && (product_detail.modifier_option_id === null || product_detail.modifier_option_id === undefined)) {
                storable = true;
                product_detail.modifiedOption.forEach(function (item) {
                    if (!(item.storable && item.storage_strict && (item.remainder[0] && item.remainder[0].quantity <= 0 || item.remainder.length === 0))) {
                        storable = false;
                    }
                });
            }

            if (product_detail.available) {
                available = lang['store.common.in_stock'];
            }
            if (storable && (remainder[0] && remainder[0].quantity <= 0 || remainder.length === 0)) {
                add_to_cart = _react3.default.createElement(
                    'p',
                    { className: 'no_good text-theme' },
                    lang['store.common.product_out_of_stock']
                );
            } else {
                add_to_cart = _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement(_components2.QuantityProduct, {
                        value: this.state.countForSendBasket,
                        checkValue: storable && remainder[0] && product_detail.modifiedOption.length === 0 ? true : false,
                        checkCount: product_detail.remainder[0] !== undefined ? remainder[0].quantity : null,
                        callback: function callback(newCount) {
                            _this3.setState({ countForSendBasket: newCount });
                        } }),
                    storable && remainder[0] && remainder[0].quantity < this.state.countForSendBasket ? _react3.default.createElement('p', { className: 'no_good' }) : _react3.default.createElement(_components2.AddToBasket, { id: 'addto-cart', className: ['huge'], product: product_detail, count: this.state.countForSendBasket })
                );
            }

            if (seo && seo.h1) {
                // если есть СЕО и в нем есть заголовок
                seoH1 = seo.h1; // отображаем его
            } else if (product_detail.name) {
                // иначе - хватаем оыбчное название товара
                seoH1 = product_detail.name;
            }
            if (product_detail.description !== null && product_detail.description !== '' && product_detail.description.indexOf('href="') !== -1) {
                product_detail.description = product_detail.description.replace(new RegExp('href="', 'g'), 'href="http://');
                product_detail.description = product_detail.description.replace(new RegExp('href="http://http', 'g'), 'href="http');
            }
            if (product_detail.faq !== null && product_detail.faq !== '' && product_detail.faq.indexOf('href="') !== -1) {
                product_detail.faq = product_detail.faq.replace(new RegExp('href="', 'g'), 'href="http://');
                product_detail.faq = product_detail.faq.replace(new RegExp('href="http://http', 'g'), 'href="http');
            }

            if (product_detail.faq) {
                return _react3.default.createElement(
                    'div',
                    { className: 'no-margin col-xs-12 col-sm-7 body-holder' },
                    _react3.default.createElement(
                        'div',
                        { className: 'body' },
                        _react3.default.createElement(_CartProduct.Breads, {
                            categories: categories,
                            onClick_Link: function onClick_Link(id, e) {
                                return _this3.onClick_BreadLink(id, e);
                            }
                        }),
                        _react3.default.createElement(
                            'div',
                            { className: 'tabs' },
                            _react3.default.createElement('input', { type: 'radio', name: 'inset', value: '', id: 'tab_1', className: 'checked' }),
                            _react3.default.createElement(
                                'label',
                                { htmlFor: 'tab_2', onClick: this.setActiveClick('tab_1') },
                                lang['store.short_description.description']
                            ),
                            _react3.default.createElement('input', { type: 'radio', name: 'inset', value: '', id: 'tab_2' }),
                            _react3.default.createElement(
                                'label',
                                { htmlFor: 'tab_1', onClick: this.setActiveClick('tab_2') },
                                lang['store.short_description.faq']
                            ),
                            _react3.default.createElement(
                                'div',
                                { id: 'txt_1' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'title' },
                                    _react3.default.createElement(
                                        'h1',
                                        { className: 'text-theme' },
                                        seoH1
                                    )
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'brand' },
                                    vendor
                                ),
                                _react3.default.createElement(_components2.SocialRow, { product: product_detail }),
                                _react3.default.createElement(_components2.ProductWishIcon, { product: product_detail, isCartProduct: true }),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'vendor_code' },
                                    _react3.default.createElement(
                                        'span',
                                        null,
                                        lang['store.common.product_vendor_code'],
                                        ': '
                                    ),
                                    _react3.default.createElement(
                                        'span',
                                        null,
                                        id_yml
                                    )
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'excerpt' },
                                    _react3.default.createElement('p', { dangerouslySetInnerHTML: { __html: product_detail.description } })
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                { id: 'txt_2' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'excerpt' },
                                    _react3.default.createElement('p', { dangerouslySetInnerHTML: { __html: product_detail.faq } })
                                )
                            )
                        ),
                        child_offers,
                        _react3.default.createElement(
                            'div',
                            { className: 'prices text-theme' },
                            _react3.default.createElement(
                                'div',
                                { className: 'price-current text-theme' },
                                _react3.default.createElement(_components2.MoneyValue, {
                                    value: price,
                                    icon: currency.icon,
                                    iconAfterValue: currency.icon_after_value
                                })
                            ),
                            old_price
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'qnt-holder' },
                            add_to_cart
                        )
                    )
                );
            }

            return _react3.default.createElement(
                'div',
                { className: 'no-margin col-xs-12 col-sm-7 body-holder' },
                _react3.default.createElement(
                    'div',
                    { className: 'body' },
                    _react3.default.createElement(_CartProduct.Breads, {
                        categories: categories,
                        onClick_Link: function onClick_Link(id, e) {
                            return _this3.onClick_BreadLink(id, e);
                        }
                    }),
                    _react3.default.createElement(
                        'div',
                        { className: 'title' },
                        _react3.default.createElement(
                            'h1',
                            { className: 'text-theme' },
                            seoH1
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'brand' },
                        vendor
                    ),
                    _react3.default.createElement(_components2.SocialRow, { product: product_detail }),
                    _react3.default.createElement(_components2.ProductWishIcon, { product: product_detail, isCartProduct: true }),
                    _react3.default.createElement(
                        'div',
                        { className: 'vendor_code' },
                        _react3.default.createElement(
                            'span',
                            null,
                            lang['store.common.product_vendor_code'],
                            ': '
                        ),
                        _react3.default.createElement(
                            'span',
                            null,
                            id_yml
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'excerpt' },
                        _react3.default.createElement('p', { dangerouslySetInnerHTML: { __html: product_detail.description } })
                    ),
                    child_offers,
                    _react3.default.createElement(
                        'div',
                        { className: 'prices text-theme' },
                        _react3.default.createElement(
                            'div',
                            { className: 'price-current text-theme' },
                            _react3.default.createElement(_components2.MoneyValue, {
                                value: this.props.product_detail.price,
                                icon: currency.icon,
                                iconAfterValue: currency.icon_after_value
                            })
                        ),
                        old_price
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'qnt-holder' },
                        add_to_cart
                    )
                )
            );
        }
    }, {
        key: 'onClick_BreadLink',
        value: function onClick_BreadLink(id, e) {
            var _this4 = this;

            e.preventDefault();
            if (id == null) {
                return;
            }
            this.props.refreshCatalog().then(function () {
                var found = (0, _utils.findCategoryDeep)(_this4.props.categories, id);
                if (found != null) {
                    _reactRouter.browserHistory.push('/category/' + id + '?limit=' + _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT + '&page=1');
                } else {
                    _reactRouter.browserHistory.push('/');
                }
            });
        }
    }]);
    return ShortDescriptionView;
}(_react2.Component), _class2.propTypes = {
    lang: _react2.PropTypes.object.isRequired,
    currency: _react2.PropTypes.object.isRequired
}, _temp)) || _class));

exports.default = ShortDescriptionView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/ShortDescription/default/ShortDescriptionView.jsx
// module id = 1631
// module chunks = 0